export enum SportFeedTypeEnum {
    Live = 1,
    Prematch = 2,
}
